module.exports = __webpack_public_path__ + "static/img/google-play-store.c3a3701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-play-store.png
// module id = KEJD
// module chunks = 67